import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContinuePaymentComponent } from './continuePayment.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [ContinuePaymentComponent]
})
export class ContinuePaymentModule { }
